import { render, staticRenderFns } from "./CardNutritionAnalysis.vue?vue&type=template&id=028c5207"
import script from "./CardNutritionAnalysis.vue?vue&type=script&lang=js"
export * from "./CardNutritionAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports